module.exports = __webpack_public_path__ + "static/media/selected.a91ab940.svg";